module.exports = __webpack_public_path__ + "static/media/master-lock-security-built-in-protection.199e5f42.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/master-lock-security-built-in-protection.png
// module id = 1270
// module chunks = 0